function Footer() {
  return (
    <footer className="footer">
      ©2023 <a href="https://tomiwa-portfolio.netlify.app">Tomiwa</a>
    </footer>
  );
}

export default Footer;
